import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getCamps } from "../../../services/campManagement"

/**
 * Camp picker for voucher lines whose ledger is sub-ledger-applicable (Camp Cost).
 * Camps are global, so this loads them once regardless of company scope. Stores the
 * react-select option {label, value} on the form field (payload reads .value as camp_id).
 */
const CampsLi = ({ control, name, onSelectChange, placeholder, disabled }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    ;(async () => {
      try {
        const res = await getCamps()
        setOptions((res?.data || []).map(c => ({ label: c.name, value: c.id })))
      } catch (e) {
        /* dropdown optional */
      }
    })()
  }, [])

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ref, value } }) => (
        <Select
          ref={ref}
          value={value}
          options={options}
          onChange={e => {
            onChange(e)
            if (onSelectChange) onSelectChange(e)
          }}
          placeholder={<div className="css-placeholder">{placeholder || "Select camp"}</div>}
          isDisabled={disabled}
          classNamePrefix="react-select"
          className="elevate-dropdown"
          menuPortalTarget={document.body}
          noOptionsMessage={() => "No camps"}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        />
      )}
    />
  )
}

export default CampsLi
